module.exports = __webpack_public_path__ + "img/tienda-6.81c7ebad.png";